"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var CityResource = /** @class */ (function (_super) {
    tslib_1.__extends(CityResource, _super);
    function CityResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CityResource.endpoint = '/cities';
    CityResource.MODEL_NAME = 'city';
    return CityResource;
}(base_1.default));
exports.default = CityResource;
//# sourceMappingURL=city.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/city.js
// module id = kCuB
// module chunks = 0